import {Found, Matched} from "./FindAndReplace";

type SearchElement = HTMLInputElement | HTMLTextAreaElement;

const MAX_RETRY = 6;
const DELAY = 500;

const ScrollBehaviour: ScrollIntoViewOptions = {
    behavior: "smooth",
    block: 'center'
};

const ELEMENT_SELECTOR = ["input", "textarea", "mat-select", "mat-chip"];

export class HighLightAndScrollTo {

    private allElements: SearchElement[] = [];
    private stop: boolean = false;

    constructor(found: Found, matched: Matched) {
        this.findAllElement(found, matched)
    }

    public destroy(): void {
        this.stop = true
    }

    public scrollToElement(matched: Matched) {
        if (!this.allElements) {
            return
        }
        const found = this.allElements.find((element) => this.validateElement(element, matched.value));

        if (found) {
            found.scrollIntoView(ScrollBehaviour);
        }
    }

    private findAllElement(found: Found, matched: Matched) {
        for (let match of found.matched) {
            if (this.stop) {
                return;
            }

            const element = this.waitForElements(match.value);

            element.then(element => {
                if (!element || this.stop) {
                    return;
                }
                for (let foundElement of element) {
                    const searchElement: SearchElement = foundElement as SearchElement;
                    this.highLightField(searchElement);
                    this.scrollTo(searchElement, matched);
                }
            })
        }
    }

    private highLightField(element: SearchElement) {
        this.allElements.push(element)
        element.classList.add("found_HighLight")
    }

    private scrollTo(element: SearchElement, matched: Matched) {
        if (this.validateElement(element, matched.value)) {
            element.scrollIntoView(ScrollBehaviour)
            element.focus();
        }
    }

    private async waitForElements(elementValue: string) {
        let found: any = []
        for (let i = 0; i < MAX_RETRY; i++) {
            if (this.stop) {
                return;
            }
            const delay = DELAY * i;
            found = await this.getElementsPromise(elementValue, delay);
            if (!!found.length) {
                return found
            }
        }
    }

    private getElementsPromise(elementValue: string, delay) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(this.findElement(elementValue));
            }, delay);
        });
    }

    private findElement(elementValue: string): SearchElement[] {

        const delegatorElement = document.getElementsByTagName("node-delegator")[0]

        if (!delegatorElement) {
            return [];
        }

        const elements: SearchElement[] = Array.from(delegatorElement.querySelectorAll(ELEMENT_SELECTOR.join()));

        if (elements === undefined || elements.length === 0) {
            return [];
        }

        return elements.filter(element => this.validateElement(element, elementValue));
    }

    private validateElement(element: SearchElement, elementValue: string) {
        if (element.localName === "mat-chip") {
            return element.textContent === ` ${elementValue} cancel`
        }
        return element.value === elementValue || element.innerText === elementValue;
    }
}

